module.exports = __webpack_public_path__ + "static/media/arch-a-1.d985f079.jpg";